import { useListState } from "@mantine/hooks";
import type { TieredPriceProductId } from "@project/common";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTRPC } from "../../../../trpc.js";
import type { TimeInterval } from "../../../../types/time.js";
import { CACHING_OPTIONS } from "../../components/constants/cachingOptions.js";
import { DATE_RANGE_PRESET } from "../constant/dateRange.js";
import type { UsageControlsProps } from "../UsageControls.js";

export function useUsageControlsProps(): UsageControlsProps {
  const trpc = useTRPC();
  const {
    data: apiKeys = [],
  } = useQuery(trpc.getApiKeys.queryOptions(undefined, CACHING_OPTIONS));

  const [apiKeyId, setApiKeyId] = useState<number>();
  const [timeInterval, setTimeInterval] = useState<TimeInterval>("day");
  const [dateRange, setDateRange] = useState(DATE_RANGE_PRESET.thisPeriod.dateRange);

  const [metricsInDetailedView, {
    append: addToDetailedView,
    remove: removeFromDetailedView,
    setState: setMetricsInDetailedView,
  }] = useListState<TieredPriceProductId>([]);

  return {
    apiKeys,
    apiKeyId,
    setApiKeyId,
    dateRange,
    setDateRange,
    timeInterval,
    setTimeInterval,
    metricsInDetailedView,
    addToDetailedView,
    removeFromDetailedView,
    clearDetailedView() {
      setMetricsInDetailedView([]);
    },
  };
};
